/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./types/api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const fetchEscClusters = /* GraphQL */ `query FetchEscClusters {
  fetchEscClusters {
    cluster
    services {
      name
      launchType
      operatingSystem
      architecture
      minTaskCount
      maxTaskCount
      desiredTaskCount
      runningCount
      pendingCount
      vCpuPerTask
      memoryPerTask
      costPerTaskPerMinute
      actualStatus
      costSavingDetails {
        enableCostSaving
        expectedTaskCount
        pricePerMinutePerTask
        status
        rules {
          shutdownAt
          startupAt
          __typename
        }
        savings {
          estimatedWeekly
          estimatedMonthly
          current
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchEscClustersQueryVariables,
  APITypes.FetchEscClustersQuery
>;
export const fetchAwsConnectionClusters = /* GraphQL */ `query FetchAwsConnectionClusters($input: FetchAwsConnectionClustersInput!) {
  fetchAwsConnectionClusters(input: $input) {
    cluster
    services {
      name
      launchType
      operatingSystem
      architecture
      minTaskCount
      maxTaskCount
      desiredTaskCount
      runningCount
      pendingCount
      vCpuPerTask
      memoryPerTask
      costPerTaskPerMinute
      actualStatus
      costSavingDetails {
        enableCostSaving
        expectedTaskCount
        pricePerMinutePerTask
        status
        rules {
          shutdownAt
          startupAt
          __typename
        }
        savings {
          estimatedWeekly
          estimatedMonthly
          current
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchAwsConnectionClustersQueryVariables,
  APITypes.FetchAwsConnectionClustersQuery
>;
export const fetchFargatePrices = /* GraphQL */ `query FetchFargatePrices($input: FargatePriceInput!) {
  fetchFargatePrices(input: $input) {
    launchType
    os
    architecture
    price {
      vcpu
      memory
      vcpuOsLicense
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchFargatePricesQueryVariables,
  APITypes.FetchFargatePricesQuery
>;
export const fetchServiceCostSavingHistory = /* GraphQL */ `query FetchServiceCostSavingHistory($input: ServiceCostSavingHistoryInput!) {
  fetchServiceCostSavingHistory(input: $input) {
    items {
      shutdownAt
      shutdownType
      startupAt
      startupType
      amountSaved
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchServiceCostSavingHistoryQueryVariables,
  APITypes.FetchServiceCostSavingHistoryQuery
>;
export const fetchAwsConnectionServiceCostSavingHistory = /* GraphQL */ `query FetchAwsConnectionServiceCostSavingHistory(
  $input: AwsConnectionServiceCostSavingHistoryInput!
) {
  fetchAwsConnectionServiceCostSavingHistory(input: $input) {
    items {
      shutdownAt
      shutdownType
      startupAt
      startupType
      amountSaved
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchAwsConnectionServiceCostSavingHistoryQueryVariables,
  APITypes.FetchAwsConnectionServiceCostSavingHistoryQuery
>;
export const estimateCostSavings = /* GraphQL */ `query EstimateCostSavings($input: EstimateCostSavingInput!) {
  estimateCostSavings(input: $input) {
    estimatedWeekly
    estimatedMonthly
    current
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimateCostSavingsQueryVariables,
  APITypes.EstimateCostSavingsQuery
>;
export const fetchOverallSavings = /* GraphQL */ `query FetchOverallSavings {
  fetchOverallSavings {
    current
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchOverallSavingsQueryVariables,
  APITypes.FetchOverallSavingsQuery
>;
export const listAwsConnections = /* GraphQL */ `query ListAwsConnections {
  listAwsConnections {
    awsConnectionId
    accountId
    roleArn
    installationId
    stackId
    status
    commercialStatus
    createdAt
    updatedAt
    lastVerifiedAt
    lastInventoryRefreshAt
    lastInventoryRefreshAttemptAt
    lastInventoryRefreshFailedAt
    lastInventoryRefreshError
    inventoryRefreshFailureCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAwsConnectionsQueryVariables,
  APITypes.ListAwsConnectionsQuery
>;
